import {DELIVERY_MODES, TAKE_AWAY, TIME_MODES} from "@/modules/delivery/constants/OrderDelivery";
import BaseOrderService from "@/modules/delivery/core/services/BaseOrderService";
import {SALON} from "@/modules/delivery/constants/OrderOrigin";


class DeliveryModeService extends BaseOrderService{
    constructor(order, settings, categoryService, branch) {
        super(order, settings, categoryService, branch);
        this.className = "DeliveryModeService";
    }

    get getMode(){
        return this.order.delivery.mode
    }

    setTable(value) {
        this.order.delivery.table = value
    }

    setMode(value) {
        if(value != null && !DELIVERY_MODES.includes(value)){
            throw new Error(`Invalid mode: ${value}. Allowed values: ${DELIVERY_MODES.join(', ')}`);
        }

        if(value !== SALON){
            this.clearOptions()
        }

        if(value === TAKE_AWAY){
            this.order.location = this.branch.location
        }else{
            this.order.location = {  localityFilter: "", address: "", floor: null, apartment: null, latitude: null, longitude: null, country: null, province: null, locality: null, place_id: null }
        }

        this.order.delivery.mode = value;


    }


    get getTimeMode() {
        return this.order.delivery.timeMode
    }
    setTimeMode(value) {
        if(!TIME_MODES.includes(value)){
            throw new Error(`Invalid time mode: ${value}. Allowed values: ${TIME_MODES.join(', ')}`);
        }
        this.order.delivery.timeMode = value;
    }

    get getTime() {
        return this.order.delivery.time
    }

    setTime(value) {
        this.order.delivery.time = value
    }

    setDate(value) {
        this.order.delivery.date = value
    }

    clearOptions(){
        this.order.delivery.timeMode = null
        this.order.delivery.time = null
        this.order.delivery.cost = 0
        this.order.delivery.distance = null
        this.order.delivery.longDistance = false
        this.order.delivery.onBar = false
    }


    get isReady(){
        if (!this.order.delivery.mode || !this.order.delivery.timeMode || !this.order.delivery.time){
            return false
        }

        if (this.order.delivery.mode === SALON && !(this.order.delivery.table || '').trim()) {
            return false
        }

        return true
    }

    setOnBar(value) {
        this.order.delivery.onBar = value;
    }


}


export default DeliveryModeService;
